<template>
  <div class="mr-4 ml-4 mt-4">
    <main class="mt-4 container">
      <slot />
    </main>
  </div>
</template>
